import {Analytics} from '../../lib/analytics/analytics';

export const analytics = new Analytics();

export const withAnalytics = analytics.withAnalytics.bind(analytics);
